// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__c8AFl","body":"layout_body__f3EfO","project":"layout_project__dU4mH","label":"layout_label__N49bq","select":"layout_select__oEoM8"};